<template>
  <!-- Add Users  -->
  <div class="modal fade" id="add-users">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Users</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <div class="profile-cover text-center">
              <label class="profile-cover-avatar" for="avatar_upload">
                <span class="empty-user"><i class="bx bxs-user"></i></span>
                <input type="file" id="avatar_upload" />
                <span class="avatar-edit">
                  <i class="bx bx-camera"></i>
                </span>
              </label>
            </div>
            <form>
              <div class="row">
                <div class="col-md-6">
                  <div class="pass-login">
                    <label class="form-label"
                      >First Name <span class="dark-red">*</span></label
                    >
                    <input type="password" class="form-control pass-input" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="pass-login">
                    <label class="form-label"
                      >Last Name <span class="dark-red">*</span></label
                    >
                    <input type="password" class="form-control pass-input" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label"
                      >Email Addess <span class="dark-red">*</span></label
                    >
                    <input type="email" class="form-control pass-input" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label"
                      >Phone Number <span class="dark-red">*</span></label
                    >
                    <vue-tel-input
                      :defaultCountry="'US'"
                      mode="international"
                      class="form-control form-control-lg group_formcontrol"
                      id="phone"
                      name="phone"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">Country</label>
                    <vue-select
                      :options="Usercounty"
                      id="usercountry"
                      placeholder="Select Country"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-check me-1"></i>Add User
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Users  -->
</template>
<script>
export default {
  data() {
    return {
      Usercounty: ["Select Country", "America"],
    };
  },
};
</script>
